<template>
  <div class="est-calc-container" :class="isGreen ? 'green' : ''">
    <div class="est-calc-inner">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: "ContentContainer",
  props: ["is-green"]
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.green {
  background: var(--primary-lightgray);
}

.est-calc-container {
  padding: 25px 15px;
}

.est-calc-inner {
  width: 90%;
  margin: 0 auto;
}

@media (min-width: $small) {
  .est-calc-inner {
    width: 90%;
    margin: 0 auto;
  }
}

@media (min-width: $medium) {
  .est-calc-container {
    padding: 50px 25px;
  }

  .est-calc-inner {
    width: 80%;
    margin: 0 auto;
  }
}

@media (min-width: $large) {
  .est-calc-container {
    padding: 75px 50px;
  }
}
</style>
